var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pcm-error-403-view"}},[_vm._v("\n    403\n")])}
var staticRenderFns = []

export { render, staticRenderFns }